<template>
  <table class="table" :class="tableClass">
    <thead>
      <slot name="columns">
        <th v-for="column in columns" :key="column">{{ column }}</th>
      </slot>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index" @click="clicked(index)" class="cursor-pointer">
        <slot name="row" :row="item">
          <td v-for="(column, index) in columns" :key="index">
            <div v-html="itemValue(item, column)"></div>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: 'paper-table',
  props: {
    columns: Array,
    data: Array,
    type: {
      type: String, // striped | hover
      default: 'striped',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    tableClass() {
      return `table-${this.type}`;
    },
  },
  methods: {
    hasValue(item, column) {
      return item[column.toLowerCase()] !== undefined && item[column.toLowerCase()] !== 'undefined';
    },
    itemValue(item, column) {
      let result = '<span> &horbar; </span>';
      if (item[column.toLowerCase()]) {
        result = '<span>' + item[column.toLowerCase()] + '</span>';
        if (item[column.toLowerCase()] === 'done') result = '<span class="checked"> &check; </span>';
        else if (item[column.toLowerCase()] === 'warning') result = '<span class="error"> &times; </span>';
      }
      return result;
    },
    clicked(index) {
      this.$emit('clicked', index);
    },
  },
};
</script>
<style>
.checked {
  color: green;
  font-size: 1.8rem;
}
.error {
  color: red;
  font-size: 1.8rem;
}
</style>
